import { Injectable } from '@angular/core';
import { Message } from "../../models/message";
import { User } from "../../models/user";

export interface MessageRecipient {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    seen: boolean;
    seenAt: string | null;
}

export interface MessageRecipients {
    recipientLabel: string;
    recipients: MessageRecipient[];
}

@Injectable({
    providedIn: 'root'
})
export class MessagesStateService {
    private activeTab: number = 0;

    // In-memory cache so going back to the list (or reopening a message) renders instantly while it refreshes
    received?: Message[];
    sent?: Message[];
    senders = new Map<string, User>();
    recipients = new Map<string, MessageRecipients>();

    setActiveTab(tabIndex: number): void {
        this.activeTab = tabIndex;
    }

    getActiveTab(): number {
        return this.activeTab;
    }

    findMessage(messageId: string): Message | undefined {
        return [...(this.received ?? []), ...(this.sent ?? [])].find((message) => message.id === messageId);
    }
}
